import { createActions } from 'redux-actions';
import * as types from 'actions/search/types';

export default createActions({}, ...Object.values(types));
